import styled from 'styled-components';

const LoadingWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loading = () => {
  return (
    <LoadingWrapper>
      <img src="/images/loading.gif" />
    </LoadingWrapper>
  );
};
